import { useContext } from "react";
import { UserInfoContext, IUserInfoContext } from "../contexts/UserInfoContext";

export const useBackendUserInfo = (): IUserInfoContext => {
  return useContext(UserInfoContext);
}; 